import tenantByHost from "@/config/tenantByHost.json";
import { IS_MULTI_TENANT } from "@/lib/tenancy";

type HostMap = Record<string, string>;

const map = tenantByHost as HostMap;

/**
 * Map Host header / window.location.host to X-Tenant-Key (must match master `tenants.tenant_key`).
 * Keys should be lowercase; port is stripped for lookup (e.g. localhost:3000 → localhost).
 */
export function resolveTenantKeyFromHost(host: string | null | undefined): string | undefined {
  if (!host || typeof host !== "string") return undefined;
  const h = host.trim().toLowerCase();
  if (map[h]) return map[h];
  const hostname = h.split(":")[0];
  if (hostname && map[hostname]) return map[hostname];
  return undefined;
}

/** Browser / client components only. No-op in standalone mode. */
export function getTenantHeadersSync(): Record<string, string> {
  if (!IS_MULTI_TENANT) return {};
  if (typeof window === "undefined") return {};
  const key = resolveTenantKeyFromHost(window.location.host);
  return key ? { "X-Tenant-Key": key } : {};
}

/** Server components: uses Next request host; client: same as sync. No-op in standalone mode. */
export async function getTenantHeadersAsync(): Promise<Record<string, string>> {
  if (!IS_MULTI_TENANT) return {};
  if (typeof window !== "undefined") {
    return getTenantHeadersSync();
  }
  try {
    const { headers } = await import("next/headers");
    const h = await headers();
    const key = resolveTenantKeyFromHost(h.get("host"));
    return key ? { "X-Tenant-Key": key } : {};
  } catch {
    return {};
  }
}
